/* eslint-disable no-unused-expressions */
import moment from 'moment';

export const LIST_SERVICES_SHOULD_APPEND_SHORT_TOKEN = [52];

export const FIELD_TYPE_PRIORITY = {
    boolean: 1,
    select: 2,
    account: 2,
    text: 3,
    integer: 4,
    number: 4,
    'period-minute': 5,
    region: 6,
    chainpoint: 7,
    directionIn: 8,
};

export const sortFieldsByPriority = (fields) => {
    if (!Array.isArray(fields)) return [];
    return [...fields].sort((a, b) => {
        const priorityA = FIELD_TYPE_PRIORITY[a?.type] ?? 99;
        const priorityB = FIELD_TYPE_PRIORITY[b?.type] ?? 99;
        return priorityA - priorityB;
    });
};

export const groupFieldsByType = (fields) => {
    if (!Array.isArray(fields)) return [];
    const sorted = sortFieldsByPriority(fields);
    const groups = [];
    let currentGroup = null;

    sorted.forEach((field) => {
        const type = field?.type || 'unknown';
        const groupKey = ['select', 'account'].includes(type) ? 'select' : type;
        if (!currentGroup || currentGroup.type !== groupKey) {
            currentGroup = { type: groupKey, items: [field] };
            groups.push(currentGroup);
        } else {
            currentGroup.items.push(field);
        }
    });

    return groups;
};

export const mapPeriodToRangeTime = (timeList) => {
    if (!timeList || !timeList.length) return [];
    return timeList.map((item) => ({
        rangeTime: [
            moment
                .utc()
                .hours(`${Math.floor((item && item.fromTime ? item.fromTime : 0) / 60)}`)
                .minutes(
                    `${(item && item.fromTime ? item.fromTime : 0) -
                    Math.floor((item && item.fromTime ? item.fromTime : 0) / 60) * 60}`
                ),
            moment
                .utc()
                .hours(`${Math.floor((item && item.toTime ? item.toTime : 0) / 60)}`)
                .minutes(
                    `${(item && item.toTime ? item.toTime : 0) -
                    Math.floor((item && item.toTime ? item.toTime : 0) / 60) * 60}`
                ),
        ],
    }));
};

export const mapRangeTimeToPeriod = (timeList) => {
    if (!timeList || !timeList.length) return [];
    return timeList.map((item) => ({
        fromTime:
            moment(item && item.rangeTime ? item.rangeTime[0] : null).hour() * 60 +
            moment(item && item.rangeTime ? item.rangeTime[0] : null).minute(),
        toTime:
            moment(item && item.rangeTime ? item.rangeTime[1] : null).hour() * 60 +
            moment(item && item.rangeTime ? item.rangeTime[1] : null).minute(),
    }));
};

export const parseInitialConfig = (configItems) => {
    let result = {};
    if (!configItems) return result;

    if (Array.isArray(configItems)) {
        configItems.forEach((item) => {
            if (item && item.type === 'period-minute') {
                result[item.field] = mapPeriodToRangeTime(item.defaultValue);
            } else if (item) {
                result[item.field] = item.defaultValue;
            }
        });
        return result;
    }

    if (typeof configItems === 'object') {
        Object.entries(configItems).forEach(([moduleKey, moduleData]) => {
            if (moduleData?.isMore === 1) {
                let singleItem = {};
                if (Array.isArray(moduleData.fields)) {
                    moduleData.fields.forEach((f) => {
                        if (f) {
                            singleItem[f.field] =
                                f.defaultValue !== undefined ? f.defaultValue : '';
                        }
                    });
                }
                result[moduleKey] = [singleItem];
            } else {
                result[moduleKey] = {};
                if (Array.isArray(moduleData?.fields)) {
                    moduleData.fields.forEach((f) => {
                        if (f) {
                            result[moduleKey][f.field] =
                                f.defaultValue !== undefined ? f.defaultValue : '';
                        }
                    });
                }
            }
        });
    }

    return result;
};
